<div class="modal-header">
  <h5 class="modal-title" id="checkInModalLabel">
    <i class="fas fa-check-circle"></i> Trả Sách
  </h5>
  <button type="button" class="close" (click)="closeModal()" aria-label="Đóng">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<!-- Nội Dung Modal -->
<div class="modal-body">
  <form [formGroup]="circulationForm" style="width: 100%; background-color: white; padding: 20px; border-radius: 5px;">
    
    <!-- Chọn Thành Viên -->
    <div class="form-group">
      <label for="memberName">Thành Viên:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn thành viên trả sách."></i>
      <ng-select id="memberName" name="memberName"
                 [items]="members$"
                 bindLabel="firstname" bindValue="id"
                 formControlName="memberName"
                 placeholder="Chọn thành viên"
                 >
      </ng-select>
    </div>

    <!-- Mã Vạch / Chọn Sách -->
    <div class="form-group">
      <label for="catalogItemName">Mục Sách:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn mã vạch của mục sách được trả."></i>
      <ng-select  id="catalogItemName" name="catalogItemName"
                 [items]="books$"
                 bindLabel="title" bindValue="id"
                 formControlName="catalogItemName"
                 placeholder="Chọn mã vạch" 
                 >
      </ng-select>
    </div>

    <!-- Ngày Đến Hạn Trả -->
    <div class="form-group mt-3">
      <label for="returnDueDate">Ngày Đến Hạn Trả:</label>
      <i class="fas fa-info-circle" data-toggle="tooltip" 
         title="Mô tả: Chọn ngày đến hạn trả sách."></i>
      <input type="date" class="form-control" id="returnDueDate" name="returnDueDate" formControlName="returnDueDate">
    </div>

    <!-- Ghi Nhớ Ngày Trả Cho Lần Tiếp Theo -->
    <div class="form-group form-check">
      <input type="checkbox" class="form-check-input" id="rememberReturnDate" name="rememberReturnDate" formControlName="rememberReturnDate">
      <label class="form-check-label" for="rememberReturnDate">Ghi nhớ ngày trả cho lần tiếp theo</label>
    </div>
    
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
  <button type="button" class="btn btn-outline-primary" (click)="add()">Trả Sách</button>
</div>


